<script>
    export let size=32;
</script>
<span class="material-icons-round" style="font-size: {size}px;"><slot></slot></span>